export default "__VITE_ASSET__pR0VusGN__"